<div [ngClass]="'accordion__container-' + type" class="accordion">
  <button
    (click)="toggleModal(!state)"
    [attr.aria-controls]="targetContent"
    [attr.aria-expanded]="state"
    [attr.aria-label]="
      showLabel ? targetText + ' of ' + modalTitle : modalTitle
    "
    [attr.data-target]="'#' + targetContent"
    [attr.id]="state ? 'hide_' + id : 'show_' + id"
    [ngClass]="['accordion__btn-' + type, 'text__position-' + positionType]"
    class="accordion__btn"
    tabindex="0"
  >
    {{ showLabel ? targetText : '' }}
    <i
      [class.expand]="state"
      [ngClass]="[
        'accordion__caret-' + caretType,
        'arrow__position-' + positionType
      ]"
      aria-hidden="true"
      class="accordion__caret"
    ></i>
  </button>
</div>
<div
  [attr.aria-labelledby]="id"
  class="collapse modalBody"
  id="modalBody_{{ index }}"
>
  Display content to show
</div>
